import React from "react";

function ModalContentSurvey({
  modalContent: {
    id,
    title,
    responses = [],
    media_url_web,
    media_url_modal = null,
    open_response,
    media_s3_tv_filename = null,
    media_s3_modal_filename = null
  }
}) {
  const percent = val => {
    let total = responses.reduce((accumulateur, rep) => {
      return accumulateur + rep.response_count;
    }, 0);
    return `${total === 0 ? 0 : Math.round((val * 100) / total)} %`;
  };
  return <div className={`Modal-wrapper ContentType--Survey ID-${id}`}>
      <div className="Modal-main">
        <div className="Modal-content">
          <p className="Modal-content-ContentType">Sondage</p>
          <h1 className="title">{title}</h1>
          <ul className="primaryText">
            {open_response ? null : responses.map(rep => (
                  <li className="response" key={rep.id}>
                    <span>{percent(rep.response_count)}</span>{" "}
                    <span className="label">{rep.response_text}</span>
                  </li>
                ))}
          </ul>
        </div>

        <div className="Modal-media">
          <div className={"Modal-media-content"}>
            <div className={"Modal-media-image"}>
              <img src={media_url_modal || media_s3_modal_filename || media_s3_tv_filename || media_url_web} alt={title} />
            </div>
          </div>
        </div>
      </div>
    </div>;
}
export default ModalContentSurvey;
